export function formatINR(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === '') return '';
  const num = typeof n === 'string' ? Number(n) : n;
  if (!Number.isFinite(num)) return '';
  return num.toLocaleString('en-IN', { maximumFractionDigits: 2 });
}

export function formatINRSymbol(n: number | string | null | undefined): string {
  const s = formatINR(n);
  return s ? `₹${s}` : '';
}

export function formatNumber(n: number | string | null | undefined, digits = 0): string {
  if (n === null || n === undefined || n === '') return '';
  const num = typeof n === 'string' ? Number(n) : n;
  if (!Number.isFinite(num)) return '';
  return num.toLocaleString('en-IN', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function formatDate(d: string | Date | null | undefined): string {
  if (!d) return '';
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

/** Today as YYYY-MM-DD (the format the API expects). */
export function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}
